






































import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { conditionFilter } from "@root/lib/common.ts";
import extentSelect from "@/components/pages/Product/extentSelect.vue";

const product = namespace("product");
const productCreate = namespace("productCreate");

@Component({ components: { extentSelect } })
export default class dynamicLoadSelect extends Vue {
  @product.Action getBrands;
  @productCreate.Action getBrand;

  @Prop({ type: Boolean, default: false }) "filterable";
  @Prop({ type: Number, default: 100 }) "pageSize";
  @Prop({ default: [] }) "selected";
  @Prop({ default: false }) "multiple";
  @Prop({ default: false }) "objValue";

  total = 0;
  list = [];
  pageNumber = 1;
  curFilter = "";
  curSelect: any = "";
  isInitDefaultBrandSingle = false; // 是否初始化过不在第一页的已选brandname(只对单选且不是选中值不为对象的情况)
  @Watch("selected", { immediate: true })
  watchSelected(val) {
    if (this.multiple) {
      if (!val || val.length === 0) {
        this.curSelect = [];
      }
    } else {
      this.curSelect = val;
    }
    if (!this.isInitDefaultBrandSingle && !this.multiple) {
      this.getDefaultBrand();
    }
  }
  async mounted() {
    // if (this.multiple) {
    //   this.curSelect = [];
    // } else {
    //   this.curSelect = "";
    // }
    await this.getList();
    if (!this.isInitDefaultBrandSingle && !this.multiple) {
      this.getDefaultBrand();
    }
  }

  get parmary() {
    let parmary: any = {
      PageInput: {
        pageNum: this.pageNumber,
        pageSize: 100
      },
      condition: {
        locale: localStorage.getItem("localeLanguage"),
        channel: localStorage.getItem("channel"),
        orgCode: "default",
        conditionList: [conditionFilter("brandName", this.curFilter, 4)]
      }
    };
    return parmary;
  }

  async getList() {
    let { list, total } = await this.getBrands(this.parmary);
    this.total = total;
    let arr = [];
    list.forEach(item => {
      let { brandName, brandCode } = item;
      arr.push({
        label: brandName,
        value: brandCode
      });
    });
    this.list = [...this.list, ...arr];
  }
  visibleStoreSelect(val) {
    if (!val && this.curFilter) {
      this.pageNumber = 1;
      this.curFilter = "";
      this.list = [];
      this.getList();
    }
  }
  LoadStoreMore() {
    if (this.total <= this.list.length) {
      return;
    }
    this.pageNumber++;
    this.getList();
  }
  searchStore(query) {
    this.curFilter = query;
    this.pageNumber = 1;
    this.list = [];
    this.getList();
  }
  changeSelect() {
    this.$emit("select", this.curSelect);
  }
  async getDefaultBrand() {
    if (!this.objValue && this.selected && this.list.length > 0) {
      this.isInitDefaultBrandSingle = true;
      let filterList = this.list.filter(_ => _.value === this.selected) || [];
      if (filterList.length === 0) {
        let brandNode = await this.getBrand({
          brandCode: this.selected,
          locale: localStorage.getItem("localeLanguage")
        });
        if (brandNode && brandNode.brandName) {
          let $brandSelet: any = this.$refs.brandSelect;
          $brandSelet.setSelectLabel(brandNode.brandName);
        }
      }
    }
  }
}
